<template>
  <div class="discover flex flex-column flex-1">
    <u-header>发现美好事物</u-header>
    <div class="scrollable container flex-1 flex flex-row">
      <p>开发中</p>
      <!-- <div class="column-1">
        <good-item v-for="goods in column1" :goods="goods" :key="goods.src"></good-item>
      </div>
      <div class="column-2">
        <good-item v-for="goods in column2" :goods="goods" :key="goods.src"></good-item>
      </div> -->
    </div>
  </div>
</template>
<script>
import GoodItem from '@/components/GoodItem'
export default {
  data () {
    return {
      column1: [],
      column2: [],
      column1Height: 0,
      column2Height: 0,
      items: [
        {
          src: 'http://lorempixel.com/320/200/food/',
          imgWidth: 320,
          imgHeight: 200,
          title: '千年人参',
          desc: '千年的人参，送老人最合适了',
          price: 9999
        }, {
          src: 'http://lorempixel.com/320/240/business/',
          imgWidth: 320,
          imgHeight: 240,
          title: '进口化妆品',
          desc: '妮维雅进口化妆品，适合送女生',
          price: 1888
        }, {
          src: 'http://lorempixel.com/320/180/food/',
          imgWidth: 320,
          imgHeight: 180,
          title: '蟠桃',
          desc: '延年益寿，大补！',
          price: 888
        }, {
          src: 'http://lorempixel.com/320/140/food/',
          imgWidth: 320,
          imgHeight: 140,
          title: '新鲜水果',
          desc: '刚采摘的，串门啥的都可以',
          price: 100
        }, {
          src: 'http://lorempixel.com/320/220/business/',
          imgWidth: 320,
          imgHeight: 220,
          title: '请帖',
          desc: '各种请帖，支持定制！',
          price: 200
        }, {
          src: 'http://lorempixel.com/320/182/food/',
          imgWidth: 320,
          imgHeight: 182,
          title: '零食特卖',
          desc: '儿时的零食，送亲朋好友最合适不过了',
          price: 199
        }, {
          src: 'http://lorempixel.com/320/210/technics/',
          imgWidth: 320,
          imgHeight: 210,
          title: '电子鞭炮',
          desc: '不能放炮？那就放电子鞭炮！',
          price: 222
        }, {
          src: 'http://lorempixel.com/320/120/business/',
          imgWidth: 320,
          imgHeight: 120,
          title: '红包',
          desc: '塞点钱，给别人发红包吧！',
          price: 66
        }
      ]
    }
  },
  components: {
    GoodItem
  },
  methods: {
    distribute (items) {
      for (const goods of items) {
        if (this.column1Height > this.column2Height) {
          this.column2.push(goods)
          this.column2Height += goods.imgHeight
        } else {
          this.column1.push(goods)
          this.column1Height += goods.imgHeight
        }
      }
    }
  },
  created () {
    this.distribute(this.items)
  }
}
</script>
<style lang="stylus" scoped>
.column-1
.column-2
  width 50%
</style>



// WEBPACK FOOTER //
// Discover.vue?3b56182f